module.exports = __webpack_public_path__ + "51be3aa13e875e94bf98c3126a400c7a.fbx";